import {
    REQUEST_LIST_FETCHING,
    REQUEST_LIST_SUCCESS,
    REQUEST_LIST_FAILED,
} from "../services/Constants";
import { RequestList } from "../types/request_list.type";
      
    export interface RequesListState {
        result: RequestList[];
        isFetching: boolean;
        isError: boolean;
    }
      
    const initialState: RequesListState = {
        result: [],
        isFetching: false,
        isError: false,
    };
      
export default (state = initialState, { type, payload}: any) => {
    switch (type) {
        case REQUEST_LIST_FETCHING:
            return { ...state, result: [], isFetching: true, isError: true };
        case REQUEST_LIST_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        case REQUEST_LIST_FAILED:
            return { ...state, result: [], isFetching: false, isError: true };
        default:
            return state;
        }
    };
      